export enum CalendarEventTypes {
  'EVENT' = 'EVENT',
  'TIMETABLE_EVENT' = 'TIMETABLE-EVENT',
}
